import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const ulcerativeColitis: AnswerPathTreeNode = {
  path: 'ulcerativeColitis',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredUlcerativeColitisDetails }],
};
